/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2023-08-17 10:17:48
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-30 18:07:49
 */
import { RouteRecordRaw } from 'vue-router'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'
const AddressSetting = () => import('@/views/address/Index.vue')
const StoreManagement = () => import('@/views/storeManagement/Index.vue')
const AdvanceManagement = () => import('@/views/enterpriseBank/advanceManagement/index.vue')
const AuditManagement = () => import('@/views/enterpriseBank/auditManagement/index.vue')
const AdvanceInquiry = () => import('@/views/enterpriseBank/advanceInquiry/index.vue')
// const FailureManagement = () => import('@/views/enterpriseBank/failureManagement/index.vue')

const sysSetting: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.STOREMANAGEMENT],
    name: 'StoreManagement',
    component: StoreManagement,
    meta: { title: NameEnum[UnionEnum.STOREMANAGEMENT], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.ADDRESS],
    name: 'AddressSetting',
    component: AddressSetting,
    meta: { title: NameEnum[UnionEnum.ADDRESS], requiresAuth: true, keepAlive: true }
  }
  // {
  //   path: UrlEnum[UnionEnum.ORDERWRITER],
  //   name: 'Order',
  //   component: CountryLetters,
  //   meta: { title: NameEnum[UnionEnum.ORDERWRITER], requiresAuth: true, keepAlive: true }
  // }
]
/**
 * @description: 包裹管理路由
 * @return {*} 派件列表 客户问询列表
 */
const packageManagement: RouteRecordRaw[] = [
  {
    path: '/orderEntry',
    name: 'OrderEntry',
    component: () => import('@my/views/packageManagement/orderEntry/Index.vue'),
    meta: { title: NameEnum[UnionEnum.ORDERWRITER], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.ORDERLIST],
    name: 'OrderQuery',
    component: () => import('@my/views/packageManagement/orderQuery/Index.vue'),
    meta: { title: NameEnum[UnionEnum.ORDERLIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/dispatchList',
    name: 'DispatchList',
    component: () => import('@/views/packageManagement/dispatchList/Index.vue'),
    meta: { title: '派件包裹列表', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/inquiryList',
    name: 'InquiryList',
    component: () => import('@/views/packageManagement/inquiryList/Index.vue'),
    meta: { title: '客户问询列表', requiresAuth: false, keepAlive: true }
  }
]
//财务结算
const financialSettlement: RouteRecordRaw[] = [
  {
    path: '/dispatchBillManagement',
    name: 'DispatchBillManagement',
    component: () => import('../views/financial-settlement/dispatch-bill-management/index.vue'),
    meta: { title: '派件费账单管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/willingnessManagement',
    name: 'WillingnessManagement',
    component: () => import('@/views/WillingnessManagement/Index.vue'),
    meta: { title: 'YoYi用户意愿管理', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/cashCollectionReport',
    name: 'CashCollectionReport',
    component: () => import('../views/cashCollectionReport/index.vue'),
    meta: { title: 'YoYi现结收款', requiresAuth: true, keepAlive: true }
  }
]
/**
 * @description: 企业银行路由
 * @return {*} 预付款管理 查询 审核 扣款失败查询
 */
const enterpriseBank: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.ADVANCE_MANAGEMENT],
    name: 'AdvanceManagement',
    component: AdvanceManagement,
    meta: { title: NameEnum[UnionEnum.ADVANCE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_ADVANCE_MANAGEMENT],
    name: 'CodAdvanceManagement',
    component: AdvanceManagement,
    meta: {
      title: NameEnum[UnionEnum.COD_ADVANCE_MANAGEMENT],
      requiresAuth: true,
      keepAlive: true,
      prepaidType: 2
    }
  },
  {
    path: UrlEnum[UnionEnum.AUDIT_MANAGEMENT],
    name: 'AuditManagement',
    component: AuditManagement,
    meta: { title: NameEnum[UnionEnum.AUDIT_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_AUDIT_MANAGEMENT],
    name: 'CodAuditManagement',
    component: AuditManagement,
    meta: { title: NameEnum[UnionEnum.COD_AUDIT_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  },
  {
    path: UrlEnum[UnionEnum.ADVANCE_INQUIRY],
    name: 'AdvanceInquiry',
    component: AdvanceInquiry,
    meta: { title: NameEnum[UnionEnum.ADVANCE_INQUIRY], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  },
  {
    path: UrlEnum[UnionEnum.COD_ADVANCE_INQUIRY],
    name: 'CodAdvanceInquiry',
    component: AdvanceInquiry,
    meta: { title: NameEnum[UnionEnum.COD_ADVANCE_INQUIRY], requiresAuth: true, keepAlive: true, prepaidType: 2 }
  }
  // {
  //   path: UrlEnum[UnionEnum.FAILURE_MANAGEMENT],
  //   name: 'FailureManagement',
  //   component: FailureManagement,
  //   meta: { title: NameEnum[UnionEnum.FAILURE_MANAGEMENT], requiresAuth: true, keepAlive: true, prepaidType: 1 }
  // },
  // {
  //   path: UrlEnum[UnionEnum.COD_FAILURE_MANAGEMENT],
  //   name: 'CodFailureManagement',
  //   component: FailureManagement,
  //   meta: {
  //     title: NameEnum[UnionEnum.COD_FAILURE_MANAGEMENT],
  //     requiresAuth: true,
  //     keepAlive: true,
  //     prepaidType: 2
  //   }
  // }
]

// 财务报表
const financialReport: RouteRecordRaw[] = [
  {
    path: '/franchiseeReport',
    name: 'FranchiseeReport',
    component: () => import('../views/financial-report/franchisee-report/index.vue'),
    meta: { title: '加盟商对账单', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/selfInvoiceReport',
    name: 'SelfInvoiceReport',
    component: () => import('../views/financial-report/self-invoice-report/index.vue'),
    meta: { title: '自开票数据汇总', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/addDeductReport',
    name: 'AddDeductReport',
    component: () => import('../views/financial-report/add-deduct-report/index.vue'),
    meta: { title: '加扣款数据汇总', requiresAuth: true, keepAlive: true }
  }
]

export { sysSetting, packageManagement, financialSettlement, enterpriseBank, financialReport }
